import React, { forwardRef } from "react";
import { useColorMode, useTheme } from "@chakra-ui/react";
import ReactSelect from "react-select";
import ReactAsyncSelect from "react-select/async";
import ReactCreatableSelect from "react-select/creatable";

// react-select no usa el tema de Chakra: sin esto, en modo noche quedaba como una caja
// blanca y el foco en el azul de la librería. Mismo uso que react-select; un `theme`
// propio se aplica encima de este.

// Los mismos tonos de navy que usan las tarjetas y los menús en modo noche.
const NEUTROS_NOCHE = {
  neutral0: "#111C44",
  neutral5: "#1B254B",
  neutral10: "#2A3566",
  neutral20: "rgba(255, 255, 255, 0.16)",
  neutral30: "rgba(255, 255, 255, 0.32)",
  // Indicadores y texto en blanco; el placeholder (50) un poco más tenue, como en los campos.
  neutral40: "#FFFFFF",
  neutral50: "rgba(255, 255, 255, 0.7)",
  neutral60: "#FFFFFF",
  neutral70: "#FFFFFF",
  neutral80: "#FFFFFF",
  neutral90: "#FFFFFF",
  dangerLight: "rgba(254, 178, 178, 0.16)",
};

/** El tema de react-select con el color de la empresa y, si toca, el modo noche. */
export const temaSelect = (base, { marca, oscuro = false }) => ({
  ...base,
  colors: {
    ...base.colors,
    ...(marca ? {
      primary: marca[500],
      primary75: marca[400],
      primary50: oscuro ? marca[700] : marca[100],
      primary25: oscuro ? NEUTROS_NOCHE.neutral5 : marca[50],
    } : {}),
    ...(oscuro ? NEUTROS_NOCHE : {}),
  },
});

export const conTemaSelect = (Componente) => {
  const ConTema = forwardRef(({ theme, ...props }, ref) => {
    const temaChakra = useTheme();
    const { colorMode } = useColorMode();
    const opciones = { marca: temaChakra?.colors?.brand, oscuro: colorMode === "dark" };

    const temaFinal = (base) => {
      const nuestro = temaSelect(base, opciones);
      if (typeof theme === "function") return theme(nuestro);
      return theme ? { ...nuestro, ...theme, colors: { ...nuestro.colors, ...(theme.colors || {}) } } : nuestro;
    };

    return <Componente ref={ref} {...props} theme={temaFinal} />;
  });
  ConTema.displayName = `ConTema(${Componente.displayName || Componente.name || "Select"})`;
  return ConTema;
};

export const AsyncSelect = conTemaSelect(ReactAsyncSelect);
export const CreatableSelect = conTemaSelect(ReactCreatableSelect);
const Select = conTemaSelect(ReactSelect);
export default Select;
